"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPermissionsMenu = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var PermissionsMenuList_1 = require("./PermissionsMenuList");
var usePermissionLevelDisplayNames_1 = require("./usePermissionLevelDisplayNames");
var SetPermissionsMenu = function (_a) {
    var permissionLevel = _a.permissionLevel, _b = _a.buttonVariant, buttonVariant = _b === void 0 ? 'ghost' : _b, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d;
    var permissionLevelDisplayNames = (0, usePermissionLevelDisplayNames_1.usePermissionLevelDisplayNames)();
    var permissionLevelDisplayName = permissionLevelDisplayNames[permissionLevel !== null && permissionLevel !== void 0 ? permissionLevel : 'none'];
    return (React.createElement(react_1.Menu, { placement: "bottom-end" },
        React.createElement(react_1.MenuButton, { as: react_1.Button, variant: buttonVariant, borderColor: "gray.300", textTransform: "capitalize", fontWeight: "400", minW: "auto", rightIcon: React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faChevronDown }), isLoading: isLoading }, permissionLevelDisplayName),
        React.createElement(PermissionsMenuList_1.PermissionsMenuList, { permissionLevel: permissionLevel, buttonVariant: buttonVariant, onChange: onChange })));
};
exports.SetPermissionsMenu = SetPermissionsMenu;
